module.exports = __webpack_public_path__ + "static/media/expertinterview.18b3ea6c.pdf";